export default __webpack_public_path__ + "static/media/non-selected-contact.8f068fdf.svg";